import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Modal from "@material-ui/core/Modal";
import RoomItem from "./ServiceItem";
import CardActions from "@material-ui/core/CardActions";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import Link from "@material-ui/core/Link";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Box from "@material-ui/core/Box";
import { loadCSS } from "fg-loadcss";
import Icon from "@material-ui/core/Icon";
import Backdrop from "@material-ui/core/Backdrop";
import Dialog from "@material-ui/core/Dialog";
import Rating from "@material-ui/lab/Rating";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import HotelDetails from "../Components/Hotels/HotelDetails";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "lg",
    padding: 0,
    marginBottom: "1%",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#F8E8E8",
  },
  rootDestacado: {
    maxWidth: "lg",
    padding: 0,
    marginBottom: "1%",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    borderStyle: "solid",
    borderWidth: "2px",
    borderColor: "#FE5215",
  },
  buttonDestacado: {
    color: "#FE5215",
    fontSize: "9px",
    borderColor: '#FE5215',
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  RoomsCard: {
    padding: 0,
    margin: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  RoomsCardAction: {
    padding: 0,
    margin: 0,
    backgroundColor: "#ffe0b2",
  },
  RoomsDescription: {
    paddingTop: "1%",
    paddingLeft: "1%",
    paddingRight: "1%",
  },
  RoomsName: {
    paddingTop: "0.7%",
    paddingRight: "0%",
    paddingBottom: 0,
  },
  RoomsDireccion: {
    flexGrow: 1,
    paddingTop: "0px",
    paddingBottom: "1%",
    direction: "row",
    justify: "center",
    alignItems: "center",
  },
  RoomsContainer: {
    paddingBottom: "0.7%",
    backgroundColor: "white",
  },
  RoomsContainerDestacados: {
    paddingBottom: "0.7%",
    backgroundColor: "#f9ebd7",
  },
  GridImagen: {
    paddingBottom: "0%",
  },
  TituloHotel: {
    color: "#3f51b5",
    // color: "#FE5215",
    fontFamily: "MontserratSemiBold"
    // fontWeight: 'bolder'
  },
  HotelAddress: {
    color: "#016AA2",
    fontStyle: "oblique",
    verticalAlign: "top",
    paddingBottom: 7,
  },
  HotelDescription: {
    display: "flex",
    alignItems: "center",
    paddingTop: "1%",
    paddingLeft: "1%",
    paddingRight: "1%",
    paddingBottom: "0%",
    marging: "0%",
    height: 70,
    color: "#757575",
  },
  appBar: {
    position: "relative",
    backgroundColor: "#016AA2",
  },
  title: {
    marginLeft: 10,
    flex: 1,
  },
  operador: {
    color: "#E0E0E0",
    fontSize: "9px",
  },
  tooltip: {
    fontSize: "9px",
    backgroundColor: "#016AA2",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow:"scroll", 
  },
  paperCancelacion: {
    backgroundColor: "white",
    border: "1px solid #FE5215",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "80%",
  },
}));

const styles = {
  dialogPaper: {
    width: "800px",
    Height: "800px",
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HotelCard(resultX, i) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const parseHtml = require('html-react-parser');

  const Tope = 2;
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  React.useEffect(() => {
    const node = loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);

  function getRoomItem(filter, hotel) {
    var iAux = 0;
    var roomsListr = resultX.hotel.map(function (item) {
      iAux = iAux + 1;
      if (filter && iAux > Tope) {
      } else {
        var mensajeReserva = "Reservar";
          if (resultX.AgenciaWeb === "Ibero" || resultX.AgenciaWeb === "MC") {
            mensajeReserva = "Solicitar";
          }
        return (
          
          <RoomItem
            key={iAux}
            onClick={bookingClick}
            bg={iAux % 2 === 0 ? "#F6F8FA" : "#e3f2fd"}
            HotelNombre={item.nombre}
            DescripcionCombinacion={item.opcion_nombre}
            Regimen={item.opcion_descripcion}
            montototal={item.precio_total}
            IDCombinacion={item.idCombinacion}
            Operador={item.operador}
            IDEncabezado={item.idEncabezado}
            hotelOperador={item.codigo+"-"+item.operador}
            moneda={item.precio_moneda}
            fechafin={item.fecha_fin}
            fechainicio={item.fecha_inicio}
            token={item.token}
            mensajeReserva={mensajeReserva}
          ></RoomItem>
        );
      }
    });
    return roomsListr;
  }

  function getStarImage(catMapeada, catOperador) {
    switch (catMapeada) {
      case "1":
        var StarCategory = (
          <Rating
            name="size-small"
            defaultValue={1}
            size="small"
            readOnly="true"
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        );
        break;
      case "2":
        var StarCategory = (
          <Rating
            name="size-small"
            defaultValue={2}
            size="small"
            readOnly="true"
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        );
        break;
      case "3":
        var StarCategory = (
          <Rating
            name="size-small"
            defaultValue={3}
            size="small"
            readOnly="true"
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        );
        break;
      case "4":
        var StarCategory = (
          <Rating
            name="size-small"
            defaultValue={4}
            size="small"
            readOnly="true"
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        );
        break;
      case "5":
        var StarCategory = (
          <Rating
            name="size-small"
            defaultValue={5}
            size="small"
            readOnly="true"
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        );
        break;
      default:
        var StarCategory = catOperador;
        break;
    }

    return StarCategory;
  }

  const bookingClick = (
    hotelOperador,
    IDCombinacion,
    Operador,
    IDEncabezado,
    token
  ) => {
    console.log("bookingClick-HotelCard");
    console.log(
      hotelOperador + " " + IDCombinacion + " " + Operador + " " + IDEncabezado+ " " + token
    );
    resultX.onClick(
      hotelOperador,
      IDCombinacion,
      Operador,
      IDEncabezado,
      resultX.tipo,
      token
    );
  };

  const handleOpen = () => {
      setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleClickOpenDialogDetails = () => {
    setOpenDetails(true);
  };

  const handleCloseDialogDetails = () => {
    setOpenDetails(false);
  };

  return (
    <React.Fragment>
      <Card
        className={classes.root}
      >
        <CardContent className={classes.RoomsCard}>
          <Grid
            container
            spacing={1}
            className={classes.RoomsContainer}
          >
            <Grid item xs={3} className={classes.GridImagen}>
              <Paper className={classes.paper}>
                <CardMedia
                  component="img"
                  alt={resultX.hotel[0].nombre}
                  height="160"
                  image={
                    resultX.hotel[0].imagen1 == null
                      ? "./NoImagen.jpg"
                      : resultX.hotel[0].imagen1
                  }
                  title={resultX.hotel[0].nombre}
                />
              </Paper>
            </Grid>
            <Grid item xs={9} className={classes.RoomsDescription}>
              <Grid container spacing={0} className={classes.RoomsName}>
                <Grid item xs={12}>
                  <Typography variant="h6" className={classes.TituloHotel}>
                   {/* <Link href="#" onClick={handleClickOpenDialogDetails}> */}
                      {" "}
                      {resultX.hotel[0].nombre}
                   {/* </Link> */}
                  </Typography>
                 
                
                    <Box display="flex" alignItems="center">
                      <Box>
                        <LocationOnIcon
                          fontSize="small"
                          className={classes.HotelAddress}
                        ></LocationOnIcon>
                      </Box>
                      <Box>
                        <Typography
                          variant="body2"
                          className={classes.HotelAddress}
                        >
                          {resultX.hotel[0].destinonombre}
                      {/*     <Typography
                          style={{ color: "white", fontSize: "10px" }}
                        > */}
                         <label style={{ color: "white", fontSize: "10px" }}>
                          {resultX.hotel[0].operador}-
                          {resultX.hotel[0].codigo}
                          </label>
                        {/* </Typography> */}
                        </Typography>
                        
                      </Box>
                    </Box>
              
                </Grid>
                {/* <Grid item xs={3}>
                  <Grid
                    container
                    direction="column"
                    justify="right"
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.TituloHotel}
                      >
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      
                        <div></div>
                 
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                          style={{ color: "#eeeeee", fontSize: "10px" }}
                        >
                          {resultX.hotel[0].operador}-
                          {resultX.hotel[0].codigo}
                        </Typography>
                    </Grid>
                  </Grid>
                </Grid> */}
              </Grid>
              <Box className={classes.HotelDescription}>
                <Typography variant="body2">
                  {resultX.hotel[0].descripcion == null ? (
                    "Sin descripción"
                  ) : resultX.hotel[0].descripcion.length > 360 ? (
                    <React.Fragment>
                      {parseHtml(resultX.hotel[0].descripcion.substring(0, 360))}{" "}
                      <Link href="#"  onClick={handleOpen}  style={{fontWeight: "bold"}}>
                        ...más información
                      </Link>
                    </React.Fragment>
                  ) : (
                    parseHtml(resultX.hotel[0].descripcion)
                  )}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          {expanded ? "" : getRoomItem(true, resultX.hotel[0].nombre)}
        </CardContent>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {getRoomItem(false, resultX.hotel[0].nombre)}
        </Collapse>
        {resultX.hotel.length > Tope ? (
          <CardActions className={classes.RoomsCardAction}>
            <div style={{ width: "100%" }}>
              {expanded ? (
                <React.Fragment>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box>
                      <IconButton
                        className={clsx(classes.expand, {
                          [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show less"
                      >
                        <Typography variant="body2">
                          Mostrar menos servicios
                        </Typography>
                        {/* <ExpandLessIcon></ExpandLessIcon> */}
                      </IconButton>
                    </Box>
                    <Box>
                      <Icon
                        className="fa fa-minus-circle"
                        fontSize="small"
                        style={{ color: "#FE5215" }}
                      />
                    </Box>
                  </Box>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box>
                      <IconButton
                        className={clsx(classes.expand, {
                          [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                      >
                        <Typography variant="body2">
                          Más servicios
                        </Typography>
                      </IconButton>
                    </Box>
                    <Box>
                      <Icon
                        className="fa fa-plus-circle"
                        fontSize="small"
                        style={{ color: "#FE5215" }}
                      />
                    </Box>
                  </Box>
                </React.Fragment>
              )}
            </div>
          </CardActions>
        ) : (
          ""
        )}
      </Card>

   {/*    <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
      >
        <PruebaGoogleMaps
          hotel={resultX.hotel[0]}
          bar={true}
        ></PruebaGoogleMaps>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDetails}
        onClose={handleCloseDialogDetails}
        TransitionComponent={Transition}
      >
        <HotelDetails
          hotel={resultX}
          bar={false}
          zoneName={resultX.zoneName}
          countryFlag={resultX.countryFlag}
        ></HotelDetails>
      </Dialog> */}

<Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paperCancelacion}>
              <React.Fragment>
                <Box display="flex" p={0} style={{ width: "100%" }}>
                  <Box flexGrow={1}>
                    <Typography variant="h5" className={classes.TituloHotelP}>
                      Información del servicio
                    </Typography>
                  </Box>
                  <Box p={0} display="flex" alignItems="center">
                    <Link href="#" onClick={handleClose}>
                      <CloseIcon fontSize="mediun" style={{color: "#016AA2"}} />
                    </Link>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  justifyContent="center"
                  verticalAlign="center"
                  flexDirection="column"
                  m={1}
                  p={1}
                  css={{ width: "100%" }}
                >
                  <Typography variant="h6" className={classes.TituloHotel}>
                    {resultX.hotel[0].nombre}
                  </Typography>
                  <Divider variant="middle" className={classes.separador} />   
                  <Typography
                    variant="subtitle1"
                    className={classes.TituloHabitacionP}
                  >
                    {parseHtml(resultX.hotel[0].descripcion)}
                  </Typography>
                </Box>
                           
              </React.Fragment>
          </div>
        </Fade>
      </Modal>

    </React.Fragment>
  );
}
